<template>
  <div>
    <navbar></navbar>
    <div class="container is-fullheight hero-body">
        <div class="columns is-centered">
            <div class="column is-6">
				        <login-logo></login-logo>
                <h3 class="title has-text-centered has-text-dark">Customer Support</h3>
                <h2>Thank you for your inquiry. We will contact you shortly. </h2>
                <div class="box">

                </div>
                <div class="has-text-centered">
                  <router-link to="/faq">Meanwhile, Try our FAQs for immediate help!</router-link>
                </div>
                <div>

                <div class="block">
    <b-icon :type="{ 'is-success': isGreen }" icon="phone"></b-icon><span>518.882.9393 </span><br>
    <b-icon :type="{ 'is-success': isGreen }" icon="email"></b-icon><span>support@normsandratios.com</span>
      </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./features/Navbar"
import LoginLogo from "./features/LoginLogo"
import SampleReports from "./SampleReports"
import BuyReports from "./BuyReports"

export default {
    name: 'Dashboard',
    data() {
        return {
			search: '',
                      checkboxGroup: [],
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
        SampleReports
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        fetchBooks() {
        },
        signUp() {
        this.$router.push({ name: "Register" });

        },
        goSampleReports() {
        this.$router.push({ name: "SampleReports" });

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue